import {
  SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM,
  SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR,
  EMAIL_ALREADY_TAKEN_ERROR,
  PROCEED_TO_NEXT_FORM_STEP,
  SET_FORM_LOADING,
} from "../actions/types";

const initialState = {
  step: 1,
  formLoading: false,
  emailError: false,
  serverError: false,
};

export default function portalAgencySignUpReducer(
  state = initialState,
  action
) {
  const { type } = action;

  switch (type) {
    case SET_FORM_LOADING:
      return {
        ...state,
        formLoading: true,
      };
    case SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM:
      return {
        ...state,
        serverError: false,
        emailError: false,
      };
    case EMAIL_ALREADY_TAKEN_ERROR:
      return {
        ...state,
        formLoading: false,
        emailError: true,
        serverError: false,
      };
    case SUBMIT_PORTAL_AGENCY_SIGN_UP_FORM_ERROR:
      return {
        ...state,
        formLoading: false,
        serverError: true,
        emailError: false,
      };
    case PROCEED_TO_NEXT_FORM_STEP:
      return {
        ...state,
        step: state.step + 1,
      };
    default:
      return state;
  }
}
